<template>
  <div class="flex flex-col gap-10">
    <div>
      <h2 class="pb-3">{{ t('e_connector.messages.messageHeaders') }}</h2>
      <InfuseJsonCodeBlock class="max-h-[36rem] overflow-y-auto" :payload="model.headers" :scrollable="false" />
    </div>

    <div>
      <h2 class="pb-3">{{ t('e_connector.messages.messagePayload') }}</h2>
      <InfuseJsonCodeBlock :payload="model.payload" :scrollable="false" class="w-full" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Message } from '@infuse/api/e-connector/message';
import { InfuseJsonCodeBlock } from '@infuse/ui/components';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

interface Props {
  model: Message;
}
withDefaults(defineProps<Props>(), {});
</script>
